<template>
  <div class="actions">
    <button v-if="!hideSave" class="button is-success" @click="save" :disabled="disabled()"><span class="icon"><i class="fal fa-save"></i></span><span>{{ saveText }}</span></button>
    <button v-if="!hideClose" class="button" @click="closePanel" :disabled="disabled()"><span class="icon"><i class="fal fa-ban"></i></span><span>{{ closeText }}</span></button>
  </div>
</template>
<script>
export default {
  props: {
    saveLabel: String,
    closeLabel: String,
    hideSave: Boolean,
    hideClose: Boolean,
    storeName: String
  },
  computed: {
    saveText: function () {
      return this.saveLabel ? this.saveLabel : 'Spara'
    },
    closeText: function () {
      return this.closeLabel ? this.closeLabel : 'Stäng'
    }
  },
  methods: {
    disabled () {
      if (this.storeName) {
        return this.$store.state[this.storeName].all.saving
      }
      return false
    },
    save: function () {
      this.$parent.$emit('emitSave')
    },
    closePanel: function () {
      this.$parent.$emit('closePanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalLayoutButtons.vue